// extracted by mini-css-extract-plugin
export var noOverflowHidden = "_81-0";
export var optionCard = "_81-1";